import { useState, useEffect } from 'react';
import { Container, Row, Col, Tabs, Tab } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import classNames from "classnames";

// Custom Component
import OverviewSection from './OverviewSection';
import MyPlayer from './MyPlayer';
import MyEarning from './MyEarning';
import ErrorAlert from '../../components/Alert/ErrorAlert';

// Images
import { Logo } from '../../assets/images/svg'

// API Service
import { getSingleTournamentService } from '../../services/tournament.service';

const SingleTournament = () => {
    const [tournament, setTournament] = useState();
    const [selectedTab, setSelectedTab] = useState('overview');

    let { tournamentId } = useParams();

    const eventList = [
        {
            label: "Men Single",
            value: "MEN_SINGLE"
        },
        {
            label: "Women Single",
            value: "WOMEN_SINGLE"
        },
        {
            label: "Men Double",
            value: "MEN_DOUBLE"
        },
        {
            label: "Women Double",
            value: "WOMEN_DOUBLE"
        },
        {
            label: "Mix Double",
            value: "MIX_DOUBLE"
        },
        {
            label: "Men 3 on 3",
            value: "MEN_3_3"
        },
        {
            label: "Women 3 on 3",
            value: "WOMEN_3_3"
        },
        {
            label: "Mix 3 on 3",
            value: "MIX_3_3"
        },
        {
            label: "Group Captain",
            value: "GROUP_CAPTAIN"
        },
        {
            label: "Junior Double",
            value: "JUNIOR_DOUBLE"
        }
        // {
        //     label: "Group 7pax",
        //     value: "GROUP_7"
        // }
    ];

    /**
        * @function fetchSingleTournament
        * @params
        * @description fetch the single tournament details
    */
    const fetchSingleTournament = async () => {
        try {
            const result = await getSingleTournamentService({
                id: tournamentId
            });
            if (result?.data?.status) {
                setTournament(result?.data?.data)
            } else {
                ErrorAlert(result?.response?.data?.message)
            }
        } catch (error) {
            ErrorAlert(error)
        }
    }

    useEffect(() => {
        fetchSingleTournament()
    }, [tournamentId])

    return <Container fluid>
        {tournament &&
            <>
                <div className='position-relative'>
                    <img className='img-fluid tournament-banner w-100' src={tournament?.banner_image} alt={tournament?.name} />
                </div>
                <Container fluid>
                    <Row>
                        <Col xs={12} lg={6} className='px-0'>
                            <Tabs
                                id="fill-tab-example"
                                className="mb-3 bg-gray p-1 rounded border-bottom-0"
                                activeKey={selectedTab}
                                onSelect={(k) => setSelectedTab(k)}
                                fill
                            >
                                <Tab eventKey="overview" title={<span className={classNames({ 'text-secondary': selectedTab !== "overview", 'text-orange': selectedTab === "overview" })}>Overview</span>}>
                                </Tab>
                                <Tab eventKey="players" title={<span className={classNames({ 'text-secondary': selectedTab !== "players", 'text-orange': selectedTab === "players" })}>Players</span>}>
                                </Tab>
                                <Tab eventKey="earnings" title={<span className={classNames({ 'text-secondary': selectedTab !== "earnings", 'text-orange': selectedTab === "earnings" })}>Earnings</span>}>
                                </Tab>
                            </Tabs>
                        </Col>
                    </Row>
                    <div className='d-flex py-2 align-items-center'>
                        <div className='me-2'>
                            <Logo />
                        </div>
                        <span className='d-lg-none fs-16 fw-600'>{tournament?.name}</span>
                        <span className='d-none d-lg-block fs-22 fw-600'>{tournament?.name}</span>
                    </div>
                </Container>
                {selectedTab === 'overview' &&
                    <OverviewSection
                        tournament={tournament}
                    />
                }
                {selectedTab === 'players' &&
                    <MyPlayer
                        tournament={tournament}
                        eventList={eventList}
                    />
                }
                {selectedTab === 'earnings' &&
                    <MyEarning
                        tournament={tournament}
                        eventList={eventList}
                    />
                }
            </>
        }
    </Container>
};

export default SingleTournament;